"use client";

export const SideEvent = () => {
	return (
		<div className={"relative w-full"}>
			<img
				src={"/events/2024techfes/cover_white.svg"}
				className={"w-full h-[24rem] object-cover"}
				alt={"cover"}
			/>
			<div
				className={
					"absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-black text-center py-16 flex flex-col gap-4 w-11/12"
				}
			>
				<h2 className={"text-4xl font-bold"}>サイドイベント</h2>
				<p>
					<span>
						エンジニアリング（少々の脱線も可）に関するサイドイベントを募集します。
					</span>
					<br />
					<span>採択された方には、運営費の一部又は全額を補助します。</span>
					<br />
					<br />
					<span>興味ある方は、下記フォームより応募待ってます。</span>
				</p>
				<button
					type="button"
					className={
						"bg-black text-white px-8 py-2 w-fit mx-auto text-2xl rounded"
					}
					onClick={(): void => {
						window.open(
							"https://docs.google.com/forms/d/e/1FAIpQLSdycQbiE-NMrAumb5NTDJuagAciM2VE7Ll8ptsiRQgYExRAug/viewform",
						);
					}}
				>
					申請する
				</button>
			</div>
		</div>
	);
};
